import { Dot } from 'pure-react-carousel';
import type { Image } from 'types/capi/shared';

type Props = {
  gallery: Image[];
};

const NavigationDots = ({ gallery }: Props) => {
  return (
    <>
      {gallery.map((slide, slideIndex) => (
        <Dot
          key={slideIndex}
          className={`size-3 rounded-3xl bg-grey-hide text-black disabled:bg-black`}
          slide={slideIndex}
        />
      ))}
    </>
  );
};

export default NavigationDots;
